import { cssTransitions } from "@styles/design-tokens/09.transitions/transitions"
import { ThemeUIStyleObject } from "theme-ui"

export const accordionContainerStyle: ThemeUIStyleObject = {
  maxWidth: "width.0",
}

export const accordionItemStyles: ThemeUIStyleObject = {
  mb: 11,
  "&:last-of-type": {
    mb: 0,
  },
}

export const titleStyles: ThemeUIStyleObject = {
  color: "darkGreen",
  fontSize: ["paragraphMedium", "paragraphMedium", "h4"],
  fontFamily: "heading",
  lineHeight: "normal",
  bg: "transparent",
  border: "none",
  cursor: "pointer",
  width: "full",
  textAlign: "left",
  pl: 0,
  pb: 2,
  borderBottomColor: "darkGreen",
  borderBottomWidth: 2,
  borderBottomStyle: "solid",
  display: "flex",
  justifyContent: "space-between",
  transition: cssTransitions.fast,
  transitionProperty: "border",
  ":hover, :focus": {
    boxShadow: "none",
  },
}

export const textStyles: ThemeUIStyleObject = {
  fontFamily: "body",
  display: "block",
  pt: 3,
}
